import script from "./ShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareModal.vue?vue&type=style&index=0&id=819f90c2&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-819f90c2"]])

export default __exports__